export default __webpack_public_path__ + "static/media/vid5.fc20d591.mp4";